import * as React from 'react';
import { SVGProps } from 'react';

const IconReplySizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#SvgIconReply_size_m__a)">
      <path d="M24 10 14 2v5c-7.063.039-13 2-13 8 0 2.747 1.5 6 4 7-1-2-3.5-9 9-9v5l10-8z" />
    </g>
    <defs>
      <clipPath id="SvgIconReply_size_m__a">
        <path d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default IconReplySizeM;
